module.exports = __webpack_public_path__ + "img/icon-hide.be7d49bc.svg";